import { Component, Inject } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { CrudService, EstimateTemplateModel, Facility } from '@mmx/shared'
import { finalize } from 'rxjs/operators'

export interface EstimateTemplateDialogData {
  facility: Facility
  estimateTemplate?: Partial<EstimateTemplateModel>
}

@Component({
  selector: 'mmx-estimate-template-dialog',
  templateUrl: './estimate-template-dialog.component.html',
  styleUrls: ['./estimate-template-dialog.component.scss'],
  standalone: false,
})
export class EstimateTemplateDialogComponent {
  saving = false

  form = this.fb.group({
    name: this.fb.control<string>(this.data.estimateTemplate?.name || '', Validators.required),
  })

  constructor(
    private dialogRef: MatDialogRef<EstimateTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EstimateTemplateDialogData,
    private crudService: CrudService,
    private fb: FormBuilder,
  ) {}

  get facilityName(): string | undefined {
    return this.data.facility?.name
  }

  save() {
    if (this.form.invalid || this.saving) {
      return
    }

    const model = new EstimateTemplateModel({
      ...this.data.estimateTemplate,
      name: this.form.controls.name.value,
      facilityIds: this.data.estimateTemplate?.facilityIds || this.data.facility?.id ? [this.data.facility.id] : [],
      charges: this.data.estimateTemplate?.charges,
    })

    this.saving = true
    this.crudService
      .save(model)
      .pipe(finalize(() => (this.saving = false)))
      .subscribe({
        next: (template) => this.dialogRef.close(template),
        error: () => this.dialogRef.close(),
      })
  }
}
